import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Router } from '@angular/router';
import { AuthHeaderComponent } from '@/app/components/global/auth-header/auth-header.component';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FooterComponent } from '../../global/footer/footer.component';
import { AuthenticationService } from '@/app/services/auth/authentication.service';
import { NgToastService } from 'ng-angular-popup';
@Component({
  selector: 'app-recover-account',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatCheckboxModule,
    FormsModule,
    AuthHeaderComponent,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FooterComponent,
    MatError,
  ],
  templateUrl: './recover-account.component.html',
  styleUrl: './recover-account.component.css',
})
export class RecoverAccountComponent {
  registerForm: FormGroup;
  isCheck = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authservice: AuthenticationService,
    private toast: NgToastService
  ) {
    this.registerForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }
  recoverAccount(email) {
    const data = {
      email: email,
    };

    this.authservice.emailCheck(data).subscribe({
      next: (response) => {
        if (response) {
          if (response?.data?.isOrg) {
            this.router.navigate(['/otp-recover-account-message']); // Navigate to OTP recovery page
          }
          if (!response?.data?.isOrg) {
            
            this.router.navigate(['/change-password'],{
              queryParams: { email: email },
            }); // Navigate to change password page
          }
        }
      },
      error: (error: any) => {
        console.error('Failed to submit:', error);
        this.toast.danger(error.msg, 'Email not found', 4000);
      },
    });
  }
  onSubmit() {
    if (this.registerForm.valid) {
      // Handle form submission
      console.log(this.registerForm.value);
    } else {
      // Handle form validation errors
      console.log('Form is invalid');
    }
  }
  setIsCheck(value: boolean) {
    this.isCheck = value;
  }
  navigateToLogin() {
    this.router.navigate(['/login']);
  }

  // New function to check the email
  checkEmail() {
    const enteredEmail = this.registerForm.get('email')?.value;
    this.recoverAccount(enteredEmail);
  }
}
